import React from "react";
import "./service-carousel.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ServiceCard from "../../atoms/service-card/service-card";

const settings = {
  dots: true,
  infinite: false,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
};

const ServiceCarousel = (props: ServiceCarouselInterface) => {
  const { cardsArray } = props;
  const displayCardsByColumn = (cardColumn) => {
    const cards: any[] = [];
    for (let c = 0; c < 4; c++) {
      let card = cardsArray[cardColumn * 4 + c];
      if (card) {
        cards.push(
          <ServiceCard
            alt={card?.tituloBanner}
            key={card?.tituloBanner + c}
            text={card?.tituloBanner}
            icon={card?.imagenPrincipal[0]?.file.url}
            href={card?.redireccionBoton}
          />
        );
      }
    }
    return cards;
  };

  const displayCardColumns = () => {
    const cardsColumn: any[] = [];

    for (let cardColumn = 0; cardColumn < cardsArray.length / 4; cardColumn++) {
      cardsColumn.push(
        <div className="center" key={cardColumn}>
          <div className="m-service-carousel">
            {displayCardsByColumn(cardColumn)}
          </div>
        </div>
      );
    }
    return cardsColumn;
  };

  return (
    <div className="slider-container show-on-mobile">
      <Slider {...settings}>{displayCardColumns()}</Slider>
    </div>
  );
};

interface ServiceCarouselInterface {
  cardsArray: any;
}

export default ServiceCarousel;
